import { Hub } from 'aws-amplify/utils';
import { CONNECTION_STATE_CHANGE, ConnectionState } from 'aws-amplify/data';
import { Injectable, inject, Injector } from '@angular/core';
import {AppLogUtils} from '../utils/log-utils';
import { GroupNotificationType } from '../amplify/types';
import { ChatMessage } from '../amplify/data-resource';
// import { GroupJourneyStore } from 'group-journey.store';
import { AmplifyService } from './amplify.service';
// import { ChatStore } from 'chat.store';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private amplifyService = inject(AmplifyService);
  private amplifyClient = this.amplifyService.getClient();
  private injector = inject(Injector); // ✅ Injected once in constructor

  private userSub: any = undefined;
  private groupJourneyStore:any=null; // ✅ Store as a lazy-loaded instance
  private chatStore:any=null; // ✅ Store as a lazy-loaded instance

  constructor() {
    // this.monitorSubscriptionState();
  }

  //This is here to avoid cyclic depencencies 
  initDeps(){
    if (!this.groupJourneyStore) {
      // this.groupJourneyStore = this.injector.get(GroupJourneyStore);
      // this.chatStore = this.injector.get(ChatStore);
    }
  }

  public refreshNotificationSubscriptions() {
    AppLogUtils.info(`refreshNotificationSubscriptions`);

    if (this.userSub) this.userSub.unsubscribe();
    this.userSub = this.amplifyClient.subscriptions.userReceive().subscribe({
      next: (event) => {
        console.log('---------- MSG ------------');
        const type = event.type as GroupNotificationType;
        console.log(type);
        switch (type) {
          case GroupNotificationType.NEW_CHAT_MESSAGE:
            this.processChatNotification(event.content);
            break;
          case GroupNotificationType.GROUP_CLOSED:
          case GroupNotificationType.USER_ADDED:
          case GroupNotificationType.USER_REMOVED:
            console.log(`Group update received`);
            this.processGroupNotification();
            break;
          default:
            AppLogUtils.info(
              `received unknown event type [${event.type}] payload [${event.content}]`
            );
            break;
        }
      },
    });

    AppLogUtils.info('Group and user subscriptions refreshed!');
  }

  private processChatNotification(content: string) {
    AppLogUtils.info(`processChatNotification [${content}]`);
    const msg = JSON.parse(content) as ChatMessage;
    this.initDeps();
    this.chatStore.pushNewMessage(msg.id,msg.chatId,msg.groupJourneyId,msg.userId,msg.createdAt,msg.content);
  }

  private processGroupNotification() {
    // ✅ Lazily inject `GroupJourneyStore`
    this.initDeps();
    this.groupJourneyStore.loadUserJourneys();
  }

  private monitorSubscriptionState() {
    Hub.listen('api', (data: any) => {
      const { payload } = data;
      if (payload.event === CONNECTION_STATE_CHANGE) {
        const connectionState = payload.data.connectionState as ConnectionState;
        AppLogUtils.debug(`Subscription state changes => `, connectionState);
      }
    });
  }
}
